<template>

    <div class="bt---atıs--dep-main">

        <div class="image-pilot" :class = "{hide : !Svgshow}">
            <img :src="getSvgStreamUrl" @error="errorsvg(0)" @load="errorsvg(1)" onerror="this.style.display='none'" alt="svg">
        </div>
        <div>
            <p v-if="!Svgshow"> Svg file couldn't get...</p>
        </div>
        <div class="field">
            <p class="heading is-size-6 has-text-centered">CLEARANCE Pilot Input</p>
        </div>

<!--        <img :src="getSvgStreamUrl" @error="errorsvg()"/>-->

<!--        <img src="../../../../assets/images/camera.png"/>-->

        <div class="content">
            <img :src="getJpegStreamUrl" @error="errorjpeg(0)" @load="errorjpeg(1)" onerror="this.style.display='none'" alt="Additional Info 2" width="100%" height="100%">
        </div>
        <div>
            <p v-if="!Jpegshow">Jpg file couldn't get...</p>
        </div>
        <div class="field">
            <p class="heading is-size-6 has-text-centered">Clearance Pilot Photo</p>
        </div>
        <div class="photo-pilot">
            <h2 style="font-size: 1.5rem; margin-left: 40px; margin-bottom: 20px">Notes</h2>
            <textarea name="clearence-text" id="" cols="20" rows="14" class="textarea" v-if="InputsObject.IF.atisClearanceText" v-model="InputsObject.IF.atisClearanceText" readonly></textarea>
        </div>

    </div>

</template>

<script>

    import {createUrl} from "../../../../http";
    import {mapState} from "vuex";

    export default {

        name: "IF-ClearanceDep",
        props: ["id", "flight", "additionalCrew"],

        data(){
            return {
                getSvgStreamUrl : "",
                getJpegStreamUrl : "",
                activeJpegUrl : createUrl('/EffIpadPreview/GetInputJpeg/'),
                activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
                Jpegshow : true,
                Svgshow : true,
            }
        },

        created()
        {
                this.getSvgStreamUrl = this.activeSvgUrl + this.id + "/" + this.flight.std + "/" +this.ActiveDevice_UID + "/" + "IF_Clearance.svg"+"/"+this.flight.flightArchiveStat;
                this.getJpegStreamUrl = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" +this.ActiveDevice_UID + "/" + "IF_Clearance.jpg"+"/"+this.flight.flightArchiveStat;
        },

        methods: {

            errorsvg(stat)
            {
                if (stat ==0)
                {
                    this.Svgshow = false;
                }
                else if(stat ==1)
                {
                    this.Svgshow = true;
                }
            },

            errorjpeg(stat)
            {
                if (stat ==0)
                {
                    this.Jpegshow = false;
                }
                else if(stat ==1)
                {
                    this.Jpegshow = true;
                }
            }
        },

        computed: {
            ...mapState("ipadmain",[ "ActiveDevice_UID","selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),
        },

        components: {

        }

    }
</script>

<style scoped>


    .photo-pilot {
        height: 400px;
        position: center;

    }

    .filepond--drop-label {
        background-color: black;
        color: #FFFFFF;
    }

    img {
        width: 100%;
    }
</style>
